<template>
  <v-flex
    md6
    xs12
    sm12
    align-center
    align-content-center
    justify-center>

    <img
      :src="logo"
      transition
      style="margin:auto; color: black; text-align: center; font-size: 20px!important;"
      width="310px">
    <h4
      v-if="false"
      style="color: white; text-align: center">{{ strings[idioma].title_bem_vindo }}</h4>
  </v-flex>
</template>
<script>
import {
  mapState
} from 'vuex'
export default {
  data () {
    return {
      background: 'img/drawer-bg.jpg',
      logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : 'img/brcorte5-logobranca.png'
      // img/br-corte-logobranca.png
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user']),
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  }
}
</script>
